module.exports = __webpack_public_path__ + "ce429c44a464a22c2bb2a066afb83af9.png";